import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

const request = async (url, options) => parseApiResponse(await apiFetch(url, options));

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) params.set(key, value);
  });
  const query = params.toString();
  return query ? `?${query}` : '';
};

const normalizeFilters = (filters) => typeof filters === 'string' ? { stage: filters } : (filters || {});

export const getAffairs = (filters = {}) => request(`/api/affairs${buildQuery(normalizeFilters(filters))}`);
export const getAffair = (id) => request(`/api/affairs/${id}`);
export const getAffairScore = (id) => request(`/api/affairs/${id}/score`);
export const createAffair = (payload) => request('/api/affairs', { method: 'POST', body: JSON.stringify(payload) });
export const updateAffair = (id, payload) => request(`/api/affairs/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const transitionAffair = (id, payload) => request(`/api/affairs/${id}/transition`, { method: 'POST', body: JSON.stringify(payload) });
export const getAffairContacts = (id) => request(`/api/affairs/${id}/contacts`);
export const updateAffairContacts = (id, payload) => request(`/api/affairs/${id}/contacts`, { method: 'PUT', body: JSON.stringify(payload) });
export const getAffairActivities = (id) => request(`/api/affairs/${id}/activities`);
export const createAffairActivity = (id, payload) => request(`/api/affairs/${id}/activities`, { method: 'POST', body: JSON.stringify(payload) });
export const getAffairDocuments = (id) => request(`/api/affairs/${id}/documents`);
export const createAffairDocument = (id, payload) => request(`/api/affairs/${id}/documents`, { method: 'POST', body: JSON.stringify(payload) });
export const uploadAffairDocument = async (id, { file, category = 'Autre', description = '' }) => {
  const response = await apiFetch(`/api/affairs/${id}/documents/upload`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-File-Name': encodeURIComponent(file.name),
      'X-Document-Category': encodeURIComponent(category),
      'X-Document-Description': encodeURIComponent(description || ''),
      'X-File-Mime-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });
  return parseApiResponse(response);
};
export const getAffairNodes = (id) => request(`/api/affairs/${id}/nodes`);
export const updateAffairNodes = (id, nodes) => request(`/api/affairs/${id}/nodes`, { method: 'PUT', body: JSON.stringify({ nodes }) });
export const getAffairMilestones = (id) => request(`/api/affairs/${id}/milestones`);
export const updateAffairMilestones = (id, payload) => request(`/api/affairs/${id}/milestones`, { method: 'PUT', body: JSON.stringify(payload) });
export const getAffairPlanningCatalog = (id) => request(`/api/affairs/${id}/planning/catalog`);
export const buildAffairPlanningTemplate = (id, payload) => request(`/api/affairs/${id}/planning/template`, { method: 'POST', body: JSON.stringify(payload) });
export const estimateAffairPlanningItem = (id, payload) => request(`/api/affairs/${id}/planning/estimate`, { method: 'POST', body: JSON.stringify(payload) });
export const getAffairPlanning = (id) => request(`/api/affairs/${id}/planning`);
export const getAffairPlanningResources = (id, filters = {}) => request(`/api/affairs/${id}/planning/resources${buildQuery(filters)}`);
export const getAffairPlanningQuoteDraft = (id) => request(`/api/affairs/${id}/planning/quote-draft`);
export const updateAffairPlanning = (id, payload) => request(`/api/affairs/${id}/planning`, { method: 'PUT', body: JSON.stringify(payload) });
export const getAffairHistory = (id) => request(`/api/affairs/${id}/history`);
export const getAffairQuotes = (id) => request(`/api/affairs/${id}/quotes`);
export const convertAffair = (id, payload = {}) => request(`/api/affairs/${id}/convert`, { method: 'POST', body: JSON.stringify(payload) });
